import { useCallback } from "react";
import axios from "axios";
import { useCreatePresignedUploadLinkMutation } from "../graphql/generated/graphql";

type UploadResult = {
  externalId: string;
  getURL: string;
};

type UploadCallback = (result: UploadResult | null, error: any) => void;

export function useFileUploader() {
  const [createPresignedUploadLinkMutation] =
    useCreatePresignedUploadLinkMutation();

  const uploadFile = useCallback(
    async (file: File, callback: UploadCallback) => {
      try {
        const { data } = await createPresignedUploadLinkMutation({
          variables: { input: { mimeType: file.type } },
        });

        const postData = data?.createPresignedUploadLink;

        if (!postData) {
          throw new Error("Failed to create presigned upload link.");
        }

        const formData = new FormData();
        Object.keys(postData.formData).forEach((key) => {
          formData.append(key, postData.formData[key]);
        });
        formData.append("file", file);

        await axios.post(postData.postURL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const result: UploadResult = {
          externalId: postData.fileKey,
          getURL: postData.getURL,
        };

        callback(result, null);
      } catch (error) {
        console.error("File upload failed:", error);
        callback(null, error);
      }
    },
    [createPresignedUploadLinkMutation]
  );

  return { uploadFile };
}
